import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DispatchAndInvoiceRequestModel } from '../../models/dispatchingAndInvoicing/dispatch-and-invoice-request.model';
import { DispatchAndInvoiceResponseModel } from '../../models/dispatchingAndInvoicing/dispatch-and-invoice-response.model';
import { CaseLoadUpdateRequestModel } from '../../models/outbound/case-load-update-request.model';
import { VolLoadResponseModel } from '../../models/dispatchingAndInvoicing/vol-load-response.model';

@Injectable({
	providedIn: 'root'
})
export class DispatchingInvoicingService {


	httpOptions = { headers: new HttpHeaders({ 'Content-type': 'application/json' }) };

	private subRoute = "dispatchingAndInvoicing/";

	constructor(private http: HttpClient) {
		this.http = http;
	}

	getInfoCase(request: DispatchAndInvoiceRequestModel): Observable<DispatchAndInvoiceResponseModel[]> {

		const urlCaseCode = `case/${request.caseCode}/`;
		const urlSubdivision = `subdivision/${request.bkSubDivisionUidD}`;

		const URL = environment.backend_Jab_url + this.subRoute + urlCaseCode + urlSubdivision;
		return this.http.get<DispatchAndInvoiceResponseModel[]>(URL, this.httpOptions);
	}

	saveCaseCode(request: DispatchAndInvoiceRequestModel): Observable<DispatchAndInvoiceResponseModel[]> {

		const urlCaseCode = `case/${request.caseCode}/`;
		const urlCaseType = request.caseType ? `casesTypes/${request.caseType}/` : 'casesTypes/0/';
		const urlUser = `user/${request.userC}/`;
		const urlSubdivision = `subdivision/${request.bkSubDivisionUidD}`;

		const URL = environment.backend_Jab_url + this.subRoute + urlUser + urlCaseCode + urlCaseType + urlSubdivision;
		return this.http.get<DispatchAndInvoiceResponseModel[]>(URL, this.httpOptions);
	}

	getLoadVolum(request: DispatchAndInvoiceRequestModel): Observable<VolLoadResponseModel> {
		const urlUser = `user/${request.userC}/`;
		const urlSubdivision = `subdivision/${request.bkSubDivisionUidD}/`;
		const urlBkLoadR = `bkLoadR/${request.bkLoadR}`;

		const URL = environment.backend_Jab_url + this.subRoute + urlUser + urlSubdivision + urlBkLoadR;

		return this.http.get<VolLoadResponseModel>(URL, this.httpOptions);
	}

	dispatchingAndInvoicing(outboundLoadUidK: number, bkSubDivisionUidD: number, modal: string): Observable<any> {
		const urlInvoice = `invoices/${outboundLoadUidK}/`;
		const modalF = `modalF/${modal}`
		const urlSubdivision = `subDivisionUidK/${bkSubDivisionUidD}/`;
		const URL = environment.backend_Jab_url + this.subRoute + urlInvoice + urlSubdivision + modalF;
		return this.http.get<DispatchAndInvoiceResponseModel[]>(URL, this.httpOptions);
	}

	getBox(bkCaseR: number, subdivision: number): Observable<DispatchAndInvoiceResponseModel[]> {
		const URL = environment.backend_Jab_url + this.subRoute + `case/${bkCaseR}/subdivision/${subdivision}`
		return this.http.get<DispatchAndInvoiceResponseModel[]>(URL);
	}

	updateDimensionBox(request: CaseLoadUpdateRequestModel) {
		const URL = `${environment.backend_Jab_url}${this.subRoute}updateDimesionBox`;
		return this.http.post(URL, request);
	}

}
